import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../site/Reveal";
import { MANUFACTURING, IMAGES } from "@/data/content";

export const Manufacturing = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section data-testid="manufacturing-section" className="relative bg-aero-deep">
      <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16">
          {/* Left: spotlight image with clipped frame */}
          <div ref={ref} className="relative">
            <div className="relative overflow-hidden rounded-2xl border border-steel/20">
              <motion.img
                style={{ y: imgY, scale: 1.12 }}
                src={IMAGES.cnc}
                alt="In-house CNC machining"
                className="aspect-[4/5] w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-aero-deep/80 via-transparent to-transparent" />
            </div>
            {/* corner ticks */}
            <span className="absolute -left-2 -top-2 h-6 w-6 border-l-2 border-t-2 border-saffron" />
            <span className="absolute -bottom-2 -right-2 h-6 w-6 border-b-2 border-r-2 border-saffron" />
          </div>

          {/* Right: numbered manifesto chapters */}
          <div className="flex flex-col justify-center">
            <Reveal>
              <span className="font-heading text-xs uppercase tracking-[0.28em] text-saffron">
                Manufacturing Capability
              </span>
              <h2 className="mt-4 font-heading text-4xl font-bold leading-[1.05] tracking-tight text-ink sm:text-5xl">
                {MANUFACTURING.heading}
              </h2>
              <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-steel">
                {MANUFACTURING.intro}
              </p>
            </Reveal>

            <div className="mt-10 space-y-8">
              {MANUFACTURING.chapters.map((ch, i) => (
                <Reveal key={ch.no} delay={i * 0.1}>
                  <div className="flex gap-5 border-t border-steel/20 pt-6">
                    <span className="font-heading text-2xl font-black text-stroke">
                      {ch.no}
                    </span>
                    <div>
                      <h3 className="font-heading text-lg font-semibold text-ink">
                        {ch.title}
                      </h3>
                      <p className="mt-2 font-body text-sm leading-relaxed text-steel">
                        {ch.body}
                      </p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
